import { CALL_API } from '../../../../common/middleware/api';

export const STRIPE_ACCESS_TOKEN_REQUEST = 'STRIPE_ACCESS_TOKEN_REQUEST';
export const STRIPE_ACCESS_TOKEN_SUCCESS = 'STRIPE_ACCESS_TOKEN_SUCCESS';
export const STRIPE_ACCESS_TOKEN_FAILURE = 'STRIPE_ACCESS_TOKEN_FAILURE';

export const STRIPE_REVOKE_ACCESS_TOKEN_REQUEST = 'STRIPE_REVOKE_ACCESS_TOKEN_REQUEST';
export const STRIPE_REVOKE_ACCESS_TOKEN_SUCCESS = 'STRIPE_REVOKE_ACCESS_TOKEN_SUCCESS';
export const STRIPE_REVOKE_ACCESS_TOKEN_FAILURE = 'STRIPE_REVOKE_ACCESS_TOKEN_FAILURE';

export const STRIPE_OAUTH_LINK_REQUEST = 'STRIPE_OAUTH_LINK_REQUEST';
export const STRIPE_OAUTH_LINK_SUCCESS = 'STRIPE_OAUTH_LINK_SUCCESS';
export const STRIPE_OAUTH_LINK_FAILURE = 'STRIPE_OAUTH_LINK_FAILURE';

export const STRIPE_ONBOARDING_STATUS_REQUEST = 'STRIPE_ONBOARDING_STATUS_REQUEST';
export const STRIPE_ONBOARDING_STATUS_SUCCESS = 'STRIPE_ONBOARDING_STATUS_SUCCESS';
export const STRIPE_ONBOARDING_STATUS_FAILURE = 'STRIPE_ONBOARDING_STATUS_FAILURE';

export const requestAccessToken = ({ code, paymentConfigurationId, useSandbox }, onSuccess, onError) => ({
    [CALL_API]: {
        types: [STRIPE_ACCESS_TOKEN_REQUEST, STRIPE_ACCESS_TOKEN_SUCCESS, STRIPE_ACCESS_TOKEN_FAILURE],
        endpoint: 'api/paymentMethods/Stripe/oauth',
        method: 'POST',
        request: { code, paymentConfigurationId, useSandbox },
        onSuccessEvent: onSuccess,
        onErrorEvent: onError
    }
});

export const revokeAccessToken = ({ paymentConfigurationId }, onSuccess, onError) => ({
    [CALL_API]: {
        types: [STRIPE_REVOKE_ACCESS_TOKEN_REQUEST, STRIPE_REVOKE_ACCESS_TOKEN_SUCCESS, STRIPE_REVOKE_ACCESS_TOKEN_FAILURE],
        endpoint: 'api/paymentMethods/Stripe/oauth/revoke',
        method: 'POST',
        request: { paymentConfigurationId },
        onSuccessEvent: onSuccess,
        onErrorEvent: onError
    }
});

export const requestOAuthLink = ({ paymentConfigurationId, returnPath, refreshPath, useSandbox }, onSuccess, onError) => ({
    [CALL_API]: {
        types: [STRIPE_OAUTH_LINK_REQUEST, STRIPE_OAUTH_LINK_SUCCESS, STRIPE_OAUTH_LINK_FAILURE],
        endpoint: 'api/paymentMethods/Stripe/oauth/link',
        method: 'POST',
        request: { paymentConfigurationId, returnPath, refreshPath, useSandbox },
        transition: {
            isExternal: true,
            successPath: (response) => {
                return response.redirectUrl;
            }
        },
        onSuccessEvent: onSuccess,
        onErrorEvent: onError
    }
});

export const checkOnboardingStatus = ({ paymentConfigurationId }, onSuccess, onError) => ({
    [CALL_API]: {
        types: [STRIPE_ONBOARDING_STATUS_REQUEST, STRIPE_ONBOARDING_STATUS_SUCCESS, STRIPE_ONBOARDING_STATUS_FAILURE],
        endpoint: 'api/paymentMethods/Stripe/oauth/verify',
        method: 'POST',
        request: { paymentConfigurationId },
        onSuccessEvent: onSuccess,
        onErrorEvent: onError
    }
});